import {GvfService} from "../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import Sortable from "sortablejs";
import {ObjectService} from "../../js/object-service";
import {FormField} from "../form-field/form-field";
import {UtilsService} from "../../js/utils-service";

export class FormFieldModelSelector extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.$input = null;
        this.$info = null;
        this.$value = null;
        this.$modal = null;
        this.$suggest = null;
        this.$modalBody = null;
    }

    addValue(id,noEvent){
        if(this.$root.data("multiple")){
            let newIds = id;
            if(!$.isArray(id)){
                newIds = [id];
            }

            let ids = [];
            if(this.$value.val()){
                ids = JSON.parse(this.$value.val());
            }

            for(let i in newIds){
                if(ids.indexOf(newIds[i])== -1){
                    ids.push(newIds[i]);
                }
            }
            this.setVal(JSON.stringify(ids),noEvent);
        }else{
            this.setVal(id,noEvent);
        }
    }

    removeValue(id,noEvent){
        if(this.$root.data("multiple") && id!==undefined){
            id = id.toString();
            let ids = [];
            if(this.$value.val()){
                ids = JSON.parse(this.$value.val());
            }
            let index = ids.indexOf(id);
            if(index== -1 && !isNaN(id)){
                index = ids.indexOf(parseInt(id));
            }
            if(index> -1){
                ids.splice(index,1);
            }
            this.setVal(ids.length>0?JSON.stringify(ids):null,noEvent);
        }
    }

    emptyValue(){
        this.$input.val("");
        this.setVal("");
    }

    openModal(search,enableLoading){
        this.$modal.modal("show");
        if(enableLoading){
            this.$modal.addClass("is-loading");
        }
        const fieldData = this.$root.data();
        fieldData.form = this.$root.closest(".js-form").getValues();
        //attach field data to modal
        this.$modal.data("fieldData",fieldData);
        this.$modal.data("refreshModal",()=>{
            this.openModal(search);
        });
        GvfService.endpoint(
            this.$root.data("endpoint")+"-list-content",
            {
                model: this.$root.data("model"),
                search: search,
                fieldData: this.$root.data(),
                context: "model-selector"
            }
        ).then(
            (resp)=>{
                this.$modal.removeClass("is-loading");
                this.$modalBody.html(resp.html);
                this.$modalBody.find(".js-search-form").submit(
                    (ev)=>{
                        ev.preventDefault();
                        this.openModal($(ev.currentTarget).getValues());
                    }
                );
                GvfUiService.init(this.$modalBody);
            }
        ).catch(UtilsService.alertEndpointResponse);
    }

    getItemId($item){
        const service = new ObjectService();
        return service.getListItemId($item);
    }

    setVal(value,noEvent,keyOrder){
        if(this.$root.data("multiple") && $.isArray(value)){
            value = JSON.stringify(value);
        }
        this.$value.val(value);
        if(this.$root.data("multiple")){
            value = value?JSON.parse(value):[];
        }
        this.$root.toggleClass("has-value",!!this.$value.val());
        this.$root.toggleClass("has-no-value",!this.$value.val());
        this.$modal.modal("hide");
        this.$info.addClass("is-loading");
        if(localStorage.getItem("keyOrder")){
            let keyOrder = JSON.parse(localStorage.getItem("keyOrder"));
            this.$root.data("key", keyOrder.key);
            this.$root.data("order",keyOrder.order);
        }
        GvfService.endpoint(
            this.$root.data("endpoint")+"-model-selector-info",
            {
                model: this.$root.data("model"),
                value: value,
                multiple: this.$root.data("multiple"),
                editable: this.$root.hasClass("is-editable"),
                fieldData: this.$root.data()
            }
        ).then(
            (resp)=>{
                this.$info.html(resp.html);
                this.$info.find(this.scope+"__item-remove").click(
                    (ev)=>{
                        const $item = $(ev.currentTarget).closest(this.scope+"__item");
                        this.removeValue($item.data("id"));
                        $item.css("opacity",0.5);
                    }
                );
                this.$info.find(this.scope+"__item-edit,"+this.scope+"__item-view,"+this.scope+"__item-clone").click(
                    (ev)=>{
                        const $item = $(ev.currentTarget).closest(this.scope+"__item");
                        const isEdit = $(ev.currentTarget).is(this.scope+"__item-edit");
                        const isView = $(ev.currentTarget).is(this.scope+"__item-view");

                        const service = new ObjectService(this.$root.data("model"));
                        service.openDetailModal(
                            {
                                objectId:$item.data("id"),
                                editMode:!isView,
                                saveCallback:(id)=>{
                                    if(isEdit){ //edited item (refresh)
                                        this.setVal(this.$root.formFieldVal(),true);
                                    }else{ //created item (add)
                                        this.addValue(id);
                                    }
                                    $item.trigger("object:updated");
                                },
                                data:this.$root.data(),
                                readyCallback:($detail)=>{
                                    if(!isEdit && !isView){
                                        $detail.find("[name=id]").val("");
                                    }
                                }
                            }
                        );
                    }
                );
                this.$info.find(this.scope+"__item-delete").click(
                    (ev)=>{
                        const $item = $(ev.currentTarget).closest(this.scope+"__item");
                        const service = new ObjectService(this.$root.data("model"));
                        service.deleteObject({ids:$item.data("id")}).then(
                            ()=>{
                                this.removeValue($item.data("id"));
                                $item.trigger("object:deleted");
                            }
                        );
                    }
                );
                if(this.$root.data("multiple") && this.$root.data("sortable") && this.$root.hasClass("is-editable")){
                    new Sortable(
                        this.$info.find(this.scope+"__items").get(0),
                        {
                            onEnd: (ev)=>{
                                const fieldValue = this.$root.formFieldVal();
                                if($.isArray(fieldValue)){
                                    const value = fieldValue.splice(ev.oldIndex,1)[0];
                                    fieldValue.splice(ev.newIndex,0,value);
                                    this.$root.formFieldSetVal(fieldValue);
                                    if(this.$root.data("parent-model-id-field")){
                                        this.setModelSelectorElementsOrder(fieldValue);
                                    }
                                }
                            }
                        }
                    );
                }

                this.$info.find(this.scope+"__item-edit-toggle,"+this.scope+"__item-edit-confirm").click(
                    (ev)=>{
                        ev.stopPropagation();
                        ev.preventDefault();
                        const $button = $(ev.currentTarget);
                        const $cell = $button.closest(this.scope+"__item-cell");
                        const $item = $button.closest(this.scope+"__item");
                        const objectId = this.getItemId($item);
                        const $field = $cell.find(".js-form-field");
                        const fieldName = $field.data("name");
                        const modelName = this.$root.data("model");
                        if($button.is(this.scope+"__item-edit-toggle")){
                            GvfService.endpoint(this.baseEndpoint+"/get-editable-field-value",{modelName,objectId,fieldName}).then(
                                (resp)=>{
                                    $field.formFieldSetVal(resp.value);
                                    $cell.toggleClass("is-editing");
                                }
                            ).catch(UtilsService.alertEndpointResponse);
                        }else{
                            $field.formFieldCheckRestrictions().then(
                                (restrictionsPassed)=>{
                                    if(restrictionsPassed){
                                        $cell.addClass("is-saving-edit");
                                        GvfService.endpoint(this.baseEndpoint+"/set-editable-field-value",{modelName,objectId,fieldName,newValue:$field.formFieldVal()}).then(
                                            (resp)=>{
                                                this.setVal(this.$value.val(),true);
                                                $item.trigger("object:updated");
                                            }
                                        ).catch(
                                            (err)=>{
                                                UtilsService.alertEndpointResponse(err);
                                                $cell.removeClass("is-saving-edit");
                                            }
                                        );
                                    }
                                }
                            );
                        }
                    }
                );

                this.$info.find(this.scope+"__item-edit-field").click(
                    (ev)=>{
                        ev.stopPropagation();
                        ev.preventDefault();
                    }
                );
                GvfUiService.init(this.$info);
            }
        ).finally(
            ()=>{
                this.$info.removeClass("is-loading");
            }
        );
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    getVal(){
        if(this.$value.val()){
            try{
                return JSON.parse(this.$value.val());
            }catch(e){ //might be a plain string value (char id for example)
                return this.$value.val();
            }
        }else{
            return null;
        }
    }

    updateLinkedDataFieldForm(firstCall){
        const $form = this.$root.closest(".js-form");
        GvfService.endpoint(
            "/cp/base-model-data-field-list/get-ref-data-field-form",
            {formData:$form.getValues()}
        ).then(
            (resp)=>{
                $form.find(".is-ref-form-field").remove();
                const $fields = $(resp.html).find(".js-form-field");
                if($fields.length>0){
                    $fields.insertAfter(this.$root);
                    $fields.addClass("is-ref-form-field");
                    GvfUiService.init($fields);
                }
                if(resp.label && !firstCall){
                    $form.findFormFieldByName("label").formFieldSetVal(resp.label);
                }
                $form.checkBindings();
            }
        ).catch(UtilsService.alertEndpointResponse);
    }

    /**
     * Sets elements order in model selector
     * @param {array} ids
     * @return {Promise<jQuery>}
     */
    setModelSelectorElementsOrder(ids){
        const parentModelId = this.$root.data("parent-model-id-field");
        const parentModel = this.$root.data("parent-model-field");
        const fieldData = this.$root.data();
        const modelName = this.$root.data("model");

        return GvfService.endpoint(
            this.baseEndpoint+"/set-model-selector-elements-order",
            {modelName,parentModel,parentModelId,ids,fieldData}
        ).catch(UtilsService.alertEndpointResponse);
    }

    ready(){
        super.ready();
        this.$input = this.findMember("input");
        this.$info = this.findMember("info");
        this.$value = this.findMember("value");
        this.$modal = this.findMember("modal").clone().appendTo($("body"));
        this.$suggest = this.findMember("suggest");
        this.$modalBody = this.$modal.find(this.scope+"__modal-body");
        this.baseEndpoint = this.$root.data("endpoint").replace(/\/render/,"")

        //store function reference to load from outside
        this.$modal.data("setValue",this.setVal.bind(this));
        this.$modal.data("addValue",this.addValue.bind(this));
        this.$root.data("openModal",this.openModal.bind(this));

        this.$root.find(this.scope+"__empty").click(
            (ev)=>{
                ev.preventDefault();
                if(this.$root.data("parent-model-id-field")){
                    const value = this.$root.formFieldVal();
                    if(value){
                        const service = new ObjectService(this.$root.data("model"));
                        service.deleteObject({ids:value}).then(
                            ()=>{
                                this.emptyValue();
                            }
                        );
                    }
                }else{
                    this.emptyValue();
                }
            }
        );

        this.$root.find(this.scope+"__search").click(
            (ev)=>{
                ev.preventDefault();
                this.openModal(null,true);
            }
        );

        this.$root.find(this.scope+"__toggle-inline").click(
            (ev)=>{
                ev.preventDefault();
                this.$root.toggleClass("is-showing-inline");
            }
        );

        this.findMember(["create","edit"]).click(
            (ev)=>{
                ev.preventDefault();
                const isEdit = $(ev.currentTarget).is(this.scope+"__edit");
                const service = new ObjectService(this.$root.data("model"));
                service.openDetailModal(
                    {
                        objectId: isEdit?this.$value.val():null,
                        editMode: true,
                        saveCallback:(id)=>{
                            if(this.$root.data("multiple")){
                                this.addValue(id); //always add item (no edit option in multiple)
                            }else{ //edited or created (set)
                                this.setVal(id);
                            }
                        },
                        data: this.$root.data()
                    }
                );
            }
        );

        this.$input.keyup(
            ()=>{
                GvfService.delay(500,"fieldmodelselectorkey").then(
                    ()=>{
                        GvfService.endpoint(
                            this.$root.data("endpoint")+"-list-content",
                            {
                                model: this.$root.data("model"),
                                search: {q: this.$input.val()},
                                blockName: "tableContent",
                                fieldData: this.$root.data(),
                                context: "model-selector-quick-search"
                            }
                        ).then(
                            (resp)=>{
                                this.$suggest.html($(resp.html));
                                this.$suggest.show();
                                this.$suggest.find(".is-item-row").click(
                                    (ev)=>{
                                        ev.preventDefault();
                                        this.addValue(this.getItemId($(ev.currentTarget)));
                                        this.$suggest.hide();
                                        this.$input.val("");
                                    }
                                ).mousedown(
                                    (ev)=>{
                                        ev.preventDefault();
                                        ev.stopPropagation();
                                    }
                                );
                            }
                        );
                    }
                );
            }
        ).keydown(
            (ev)=>{
                const codeK = ev.keyCode || ev.which;
                if(codeK==13){ //intro
                    ev.preventDefault();
                }
            }
        ).blur(
            ()=>{
                this.$suggest.hide();
            }
        ).on("focus click",
            ()=>{
                this.$suggest.show();
            }
        );

        if(this.$root.data("is-data-field-selector")){
            this.$root.on(
                "formField:changeVal",
                ()=>{
                    this.updateLinkedDataFieldForm();
                }
            );
            this.updateLinkedDataFieldForm(true);
        }

        //initial load
        if(this.$value.val() && this.$info.html()==""){
            this.setVal(this.$value.val(),true);
        }
    }
}

